import { withTheme } from 'styled-components/macro'
import React from 'react'
import { MdAddCircle } from 'react-icons/md'
import CircleButton from '../CircleButton/CircleButton'
import PropTypes from 'prop-types'

const AddButton = React.memo(({ isactive, theme, size, iconStyle, ...rest }) => {
  const circleStyle = {
    zIndex: 2,
    width: size || '3.6rem',
    height: size || '3.6rem',
    ...iconStyle
  }
  return (
    <CircleButton
      fill={theme.productPlusButtonIcon}
      isactive={isactive}
      size={size}
      {...rest}
    >
      <MdAddCircle
        style={circleStyle}
        color={theme.productPlusButtonBackground}
      />
    </CircleButton>
  )
})

AddButton.displayName = 'AddButton'

AddButton.propTypes = {
  isactive: PropTypes.bool,
  size: PropTypes.string,
  theme: PropTypes.object.isRequired,
  iconStyle: PropTypes.object
}

export default withTheme(AddButton)
export { AddButton }
